import React, { Component } from 'react'
import Header from '../components/Header'
import Card1 from '../components/cards/Card1'
import { connect } from 'react-redux';
import { changeStateValue } from '../redux/MainReducer';
import { getFounderAbout } from '../actions/MainAction';
export class AboutPage extends Component {
  openModal=(data, lang, lang_id=1)=>{
    // console.log(lang, lang_id)
    this.props.changeStateValue({
      name:"mainModal",
      value:{
        position:true,
        id: data?.id?data?.id:"",
        image: data?.image?data?.image:"",
        image_full_url: data?.image_full_url?data?.image_full_url:"",
        youtube: data?.youtube?data?.youtube:"",
       
        languages:{
          id:lang?.id?lang?.id:'',
          title:lang?.title?lang?.title:'',
          description:lang?.description?lang?.description:'',
          lang_id:lang_id
        }
        ,
        requiredsLang: ["title"],
        requireds:[],
        afterCallFunction:this.props.getFounderAbout,
        afterParams:[],
        url:'admin-about-founder'
      }
    })
  }

  componentDidMount(){
    this.props.getFounderAbout()
  }
  render() {
    const {aboutData} = this.props;
    return (
      <div className='p-[40px] w-full'>
        <Header btn={false} onClickBtn={this.openModal.bind(this, "", "", 1)} title="Founder About" />
        <div className='grid-full-250 grid grid-cols-2 mt-[20px]'>
          {
            aboutData?
                <Card1 
                  onChangeLang={(id)=>this.openModal(aboutData, aboutData.translates.find(x=>x.lang_id==id), id)} 
                  title1={aboutData?.translate?.title}
                  image={aboutData?.image_full_url}
                  deleteUrl={`admin-about-founder/${aboutData?.id}`}
                  afterCallFunction={()=> this.props.getFounderAbout()}
                  deleteBtn={false}
                />:null
          }
        </div>
      </div>
    )
  }
}
const mapStateToProps = (state)=>({
  aboutData: state.Data.aboutData
});
const mapDispatchToProps = {changeStateValue, getFounderAbout}
export default connect(mapStateToProps, mapDispatchToProps)(AboutPage)




